import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { Metamodel } from 'app/model/base/model';
import { HubSpotObjectDataset } from 'app/model/dataset/hub-spot.dataset';
import { HubSpotLinkedService } from 'app/model/linkedservice/hub-spot.linkedservice';
import { GlobalVariables } from 'app/services/globals';
import { format } from 'app/shared/utils/string.util';

export const hubspotObjectMetadata: IDatasetTypeMetadata = {
    type: Metamodel.modelFor(HubSpotObjectDataset).name,
    displayName: stringResources.Hubspot_DisplayText,
    supportLinkedServiceTypes: [Metamodel.modelFor(HubSpotLinkedService).name],
    isSource: true,
    isSink: false,
    showWarningMessage: '{ linkedService && linkedService.version !== "v2" }',
    warningMessage: format(
         stringResources.Dataset_Legacy_IsNotSupportedWarning_alt3,
         stringResources.VersionLabel.toLocaleLowerCase()),
    warningMessageHyperlink: 'https://learn.microsoft.com/azure/data-factory/connector-hubspot',
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-hubspot'
    },
    isFirstClass: true,
    supportCreatedAsV2: true,
    notSupportPhysicalType: true,
    splitTablePath: GlobalVariables.enableTableNameSplitForHubspotV2,
    preserveOriginalTableFormat: GlobalVariables.enableTableNameSplitForHubspotV2,
    separator: '.',
    isTableNameRequired: GlobalVariables.enableTableNameSplitForHubspotV2 ? false : `{ linkedService && linkedService.version === "v2" }`,
    isTableRequired: GlobalVariables.enableTableNameSplitForHubspotV2,
    notSupportCopySourceQuery:  `{ linkedService && linkedService.version === "v2" }`,
    v1SupportSchema: true,
    category: ['ServicesApps']
};
